import React, { useState } from "react";
import { Icon } from "@blueprintjs/core";
export default function AdvancedOptions(_ref) {
  var children = _ref.children,
      content = _ref.content,
      label = _ref.label,
      isOpenByDefault = _ref.isOpenByDefault;

  var _useState = useState(isOpenByDefault),
      isOpen = _useState[0],
      setOpen = _useState[1];

  if (!(content || children)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setOpen(!isOpen);
    },
    style: {
      cursor: "pointer"
    }
  }, label || "Advanced", " ", /*#__PURE__*/React.createElement(Icon, {
    icon: isOpen ? "caret-up" : "caret-down"
  })), isOpen && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10
    }
  }, content || children));
}